import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessBoardEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-board-embed',
	path: '/jira/core/projects/:projectKey/board/embed',
	exact: true,
};
